<template>
  <div class="layout auerbach_wrap">
    <p>认证成为专业买家，获取更多合作机会</p>
    <van-form
      @submit="onSubmit"
      class="auer_auth_form"
      scroll-to-error
      error-message-align="right"
      input-align="right"
    >
      <van-field
        v-model="authForm.name"
        name="name"
        label="姓名"
        placeholder="请输入"
        maxlength="7"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
              v-model="authForm.company"
              name="company" label="公司"
              maxlength="20"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入公司' }]"/>
      <van-field
              v-model="authForm.department"
              name="department"
              label="部门"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入部门' }]"/>
      <van-field
              v-model="authForm.jobTitle"
              name="jobTitle"
              label="职务"
              placeholder="请输入"
              maxlength="10"
              :rules="[{ required: true, message: '请输入职务' }]"/>
      <van-field
        readonly
        clickable
        name="city"
        :value="authForm.city"
        right-icon="arrow"
        label="城市"
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择城市' }]"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :value="cityCode"
          :area-list="areaList"
          @confirm="onCity"
          @cancel="showArea = false"
          :columns-placeholder="['请选择', '请选择', '请选择']"
        />
      </van-popup>
      <van-field v-model="authForm.address"
                 name="address"
                 label="详细地址"
                 placeholder="请输入"
                 :rules="[{ required: true, message: '请输入详情地址' }]"/>
      <!-- <van-field
        readonly
        clickable
        name="care"
        :value="authForm.care"
        right-icon="arrow"
        label="感兴趣的类别"
        placeholder="请选择"
        @click="regCareShow"
      >
        <template #button></template>
      </van-field> -->
      <div class="van-cell" name="care" @click="regCareShow()" >
        <div class="van-cell__title"><span>感兴趣的类别</span></div>
        <div class="van-cell__value">
          <div class="van-field__body">
            <div class="van-field__control van-field__control&#45;&#45;right care_input">{{authForm.category.length>0?'已选择':'请选择'}}<span v-if="authForm.category.length>0">{{categoryNum}}</span>{{categoryNum>0?'个':''}} </div>
            <div class="van-field__right-icon">
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
      </div>
      <div class="care_uploading">
        <div class="uploading_wrap" @click="uploadOk" v-if="!authForm.businessCard">
          <i class="van-icon van-icon-plus van-uploader__upload-icon"></i>
          <span>上传名片</span>
        </div>
        <div class="uploading_ok"  v-if="authForm.businessCard">
          <i @click="authForm.businessCard=''" class="van-icon van-icon-clear van-uploader__preview-delete"></i>
          <img :src="authForm.businessCard">
        </div>
      </div>
      <!-- <van-uploader class="care_uploading" v-model="cardList" upload-text="上传名片" :after-read="uploadOk" :before-delete="upadDelete" :max-count="1"  upload-icon="plus"/> -->
      <van-button class="sumbit_btn" color="#f85b0f" block type="info" native-type="submit" @click="showPopup">保存并提交</van-button>
    </van-form>
    <reg-care @careCheck="careUpData" ref="regCare" v-bind:list="categoryList1"></reg-care>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import regCare from "@components/reg-care";
import provincial from '@/assets/js/provincial.json';     //省市区json
export default {
  name: "registry",
  components: {
    regCare
  },
  data() {
    return {
      authForm: {

      },
    // {
    //     name: "王涛", //昵称
    //     companyName: "慕渊（上海）智能科技有限公司", //公司名称
    //     department: "产品部", //部门
    //     job: "总经理", //职务
    //     city: "上海市/上海市/嘉定区", //城市
    //     address: "", //详细地址
    //     category: [1], //感兴趣的类别
    //     cardImg: "" //名片
    //   },

      businessCard:'', //名片
      cityCode:'',  //省市区编号，默认
      showArea: false, //城市选择弹出框
      //城市选择列表
      areaList: {},
      categoryNum:'', //感兴趣的类别个数
      show:false,
      newlist:[], //感兴趣类型的数组
      categoryList:[],
      categoryList1:[], //感兴趣类型的选中id数组
      city:'',
    };
  },
  created(){
    this.areaList=provincial;
    this.getUser()
  },
  mounted() {
    if(this.authForm.city&& this.authForm.province&&this.authForm.county)
    {
      console.log(this.authForm.county)
      let name=this.userInfo.county;
      console.log(name,'城市区名')
      this.cityCode=this.getCityCode(name);
    }else if(this.authForm.city&& this.authForm.province){
      console.log(this.authForm.city)
      // let name=this.userInfo.city
      let index = this.userInfo.city .lastIndexOf("/")
      let name=this.userInfo.city.substring(index+1,this.userInfo.city.length)
      this.cityCode=this.getCityCode(name);
      console.log(name,'城市名')
    }else
    {
      console.log(this.authForm.province)
      let name=this.userInfo.province;
      this.cityCode=this.getCityCode(name);
      console.log(name,'省名')
    }

  },
  computed: {
    ...mapGetters({
      userId: 'getUserId',
      inMemberId: 'getInMemberId',    //观众信息id 修改个人信息用
      exhibitionId:'getExhibitionId',
      userInfo:'getUserInfo'
    }),
  },
  methods: {
    ...mapActions({
      sendCode: "login/sendCode",
      validateCode: "login/validateCode",
      memberUpdate:'login/memberUpdate',
      getUserinfo:'login/getUser',
      wxUpLoadImg:'upload/wxUpLoadImg'
    }),
    showPopup() {
      this.show = true;
    },
    async getUser(){
      console.log("获取了数据库数据",this.userInfo)
      this.authForm =this.userInfo;
      if (this.userInfo.province&&this.userInfo.city&&this.userInfo.county){
        this.authForm.city = this.userInfo.province+'/'+this.userInfo.city+'/'+this.userInfo.county

      }
      else if (this.userInfo.province&&this.userInfo.city){
        this.authForm.city = this.userInfo.province+'/'+this.userInfo.city
      }
      else {
        this.authForm.city = this.userInfo.province
      }

      if (this.authForm.category != null &&this.authForm.category !=''){
        let a=JSON.parse(this.authForm.category) //把返回的兴趣类型字符串转json
        for (let i=0;i<a.length;i++){
          console.log(a[i].Lists)
          this.categoryList = [...this.categoryList,...a[i].Lists]
        }
        this.categoryNum =this.categoryList.length // 获取感兴趣类型的个数
        for (let j=0;j<this.categoryList.length;j++){
          this.categoryList1.push(this.categoryList[j].Id)
        }
        console.log(this.categoryList1,'auegfusehbfusrygferuygfsurygfweuygfyew')
      }else {
        this.authForm.category = []
      }
      //名片
      // this.authForm.businessCard='http://img0.imgtn.bdimg.com/it/u=2157014178,196343208&fm=26&gp=0.jpg'
    },
    //城市选择确认
    onCity(values) {
      let cityarr=[];
      values.map((item)=>{
        if(item&&item.name!=''){
          cityarr.push(item.name)
        }
        else{
          return 
        }
        });
      this.authForm.city=cityarr.join('/');

      this.showArea=false;
      console.log(this.authForm.city)
    },
    //表单提交
   async onSubmit(values) {
      if(this.categoryNum ==0||''){
        this.$toast.fail('请选择感兴趣的类别')
        return
      }
      if (!this.authForm.businessCard){
        this.$toast.fail('请上传个名片')
        return
      }
      console.log(this.authForm.category)
      let city1 = this.authForm.city.split("/") //将城市转化为一个数组
      console.log(city1)
      console.log(city1[0])
      console.log(city1[1])
      console.log(city1[2])
       if (city1[0] != undefined){
         this.authForm.province = city1[0]
       }
       else{
         this.authForm.province =''
       }
      if (city1[1] != undefined){
        this.authForm.city = city1[1]
      }
      else{
        this.authForm.city =''
      }
      if (city1[2] != undefined){
        this.authForm.county = city1[2]
      }
      else {
        this.authForm.county =''
      }

      //判断感兴趣的类别
      if (this.authForm.category .length>0 && this.newlist.length>0){
        console.log("aaa")
        let category1 = JSON.stringify(this.newlist) //将感兴趣的类别转化为字符串
        console.log(category1)
        this.authForm.category = category1
      }
      else if (this.newlist.length ==0 &&this.authForm.category.length ==0){
        this.authForm.category = ''
      }
      this.authForm.company = values.company
      this.authForm.name = values.name
      this.authForm.jobTitle = values.jobTitle
      this.authForm.address = values.address;
      this.authForm.inMemberId = this.inMemberId
      console.log(this.authForm,'233');
       let res= await  this.memberUpdate(this.authForm)
        // let res=await false;
        if(res.result ==true&&this.userInfo.userRole ==2){
          this.$toast.success('提交成功')
        }else{
          this.$toast.success('提交成功，等待后台审核');
        }
     this.getUserinfo()
     this.$router.go(-1);
      console.log( this.authForm.category);
    },
    //得到当前城市name对应的code
    getCityCode(name){
      for(let item in this.areaList){
        for(let code in this.areaList[item]) {
            if(this.areaList[item][code]==name)
            {
              return code
            }
        }
      }
    },
    async uploadOk() {  // 上传名片
      const that = this; 
      const callBack = (data) => { 
        console.log('名片coverImg', data);
      };
      const img = await this.wxUpLoadImg(callBack); 
      console.log('上传的名片：', img);
      if(img){
        this.authForm.businessCard = img;
      }else{
        this.$toast.fail('上传失败');
      }
    },
    //删除名片前
    upadDelete(file){
      this.authForm.care='';
      return true
    },
    //点击感兴趣选择
    regCareShow(){
      console.log("ccc")
      this.$refs['regCare'].open();
    },
    //感兴趣数据更新
    careUpData(vals,newlist){
      this.categoryList1 = vals
      console.log(newlist,'awdawdawdawdawdaddddd')
      this.newlist = newlist
      this.categoryNum = vals.length
      this.authForm.category=vals;
    }
  }
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.auerbach_wrap {
  background: #131825;
  padding: 0 0.24rem 0.98rem;
  > p {
    line-height: 0.62rem;
    height: 0.62rem;
    color: #bfbfbf;
  }
  .auer_auth_form {
    border-top: 1px solid #1d2435;
    &::v-deep .van-cell {
      background: transparent;
      color: #fff;
      padding: 0.3rem 0;
      border-bottom: 1px solid #1d2435;
      font-size: 0.3rem;
      &.input_brief {
        border-bottom: none;
        padding: 0.2rem;
        background: #1d2435;
        border-radius: 0.03rem;
        height: 1.9rem;
        .van-cell__value {
          .van-field__body {
            .van-field__control {
              font-size: 0.24rem;
              line-height: 0.28rem;
             
            }
          }
        }
      }
      &::after {
        display: none;
      }
      .van-cell__value {
        .van-field__body {
          .van-field__right-icon{
              padding: 0 0.2rem 0 0;
              i{
                font-size: 0.24rem;
              }
            }
          .van-field__control {
            font-size: 0.3rem;
            color: #bfbfbf;
            &.care_input{
               text-align: right;
              span{
                font-size: 0.3rem;
                color: #f85b0f;
                text-overflow:ellipsis; overflow:hidden;
                margin: 0 0.05rem 0 0.08rem;
              }
            }
          }
          .send_code {
            font-size: 0.3rem;
            color: #f85b0f;
          }
        }
      }
      .van-cell__title {
        white-space:nowrap; 
        span {
          font-size: 0.3rem;
        }
      }
    }
    > p {
      font-size: 0.3rem;
      color: #fff;
      line-height: 1;
      padding: 0.35rem 0 0.2rem;
    }
    .sumbit_btn {
      font-size: 0.36rem;
      height: 0.98rem;
      line-height: 0.98rem;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 0;
      span {
        font-size: 0.36rem;
      }
    }
    
    .care_uploading{
      margin: 0.5rem auto;
      display: block;
      width: 6rem;
      height: 3.35rem;
      background: #1d2435;
      .uploading_wrap{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #fff;
        i{
          display: inline-block;
          font-size: 0.64rem;
          color: #fff;
        }
        span{
          margin-top: 0.16rem;
          color: #fff;
          font-size: 0.3rem;
        }
      }
      .uploading_ok{
        width: 100%;
        height: 100%;
        position: relative;
        img{
          // object-fit: cover;
          display: block;
          width: 100%;
          height: 100%;
        }
        i{
          // color: transparent;
          // background: #fff;
        }
      }
    }
  }
}
</style>
